import Skeleton from '@s-ui/react-atom-skeleton'

import {
  DEFAULT_NUMBER_OF_THUMBNAILS,
  THUMBNAILS_WRAPPER_SKELETON_CLASS,
  THUMBNAILS_WRAPPER_SKELETON_STYLES
} from '../../config.js'

const GalleryBasicThumbnailsWrappersSkeleton = () => {
  return (
    <div className={THUMBNAILS_WRAPPER_SKELETON_CLASS}>
      {new Array(DEFAULT_NUMBER_OF_THUMBNAILS).fill().map((_, index) => (
        <Skeleton
          key={index}
          height={THUMBNAILS_WRAPPER_SKELETON_STYLES.height}
          style={{...THUMBNAILS_WRAPPER_SKELETON_STYLES}}
        />
      ))}
    </div>
  )
}

GalleryBasicThumbnailsWrappersSkeleton.displayName = 'GalleryBasicThumbnailsWrappersSkeleton'

export default GalleryBasicThumbnailsWrappersSkeleton
